module.exports = __webpack_public_path__ + "img/002-clothes.08ad4f89.svg";